/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_Description_TitlecaseInputs */



/**
* | output |
* | --- |
* | "Shot Description" |
*
* @param {Ccsl_Export_Header_Shot_Description_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_description_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Shot_Description_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_Description_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schussbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dello scatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de la toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da cena")
	return /** @type {LocalizedString} */ ("Shot Description")
});